module.exports = __webpack_public_path__ + "9cae967bcea9f9e207b036ebc891e709.png";